import * as React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { counterTrigger } from 'Tools/counters';
import { snitchCounter } from 'Tools/counters/snitchCounter';
import FinishedQuizItem from './FinishedQuizItem';
import Loader from '@media-ui/core/src/components/Loader';
import ScrollSnap from 'Components/ScrollSnap';
import LayoutContext from 'Context/LayoutContext';
import { status } from 'Containers/Quiz/modules/actions';
import RefreshIcon from 'Icons/quiz/refresh.svg';
import s from './FinishedQuiz.css';
import * as T from './FinishedQuiz.types';
import Title from '@media-ui/core/src/components/Title';
import Wrapper from '@media-ui/core/src/components/Wrapper';
const FinishedQuiz: React.FunctionComponent<T.IFinishedQuiz> = ({ type, onRestart, }) => {
    const { isMobile } = React.useContext(LayoutContext);
    const { items, status: actionStatus } = useSelector((state: any) => state.compilations);
    const isDog = type === 'dog';
    React.useEffect(() => {
        counterTrigger(isDog ? 'quizDogRecommend' : 'quizCatRecommend');
    }, []);
    const title = isDog ? 'Ваша идеальная собака' : 'Ваша идеальная кошка';
    /**
     * Отрисовать список карточек с рекомендациями
     */
    const renderItems = () => {
        if (!items) {
            return null;
        }
        return items.map((item: T.IFinishedQuizItem, index: number) => {
            const clickHandler = () => {
                snitchCounter('petQuizPickBreed', {
                    breed: item.name,
                });
            };
            return (<FinishedQuizItem {...item} onClick={clickHandler} key={`compilation-item-${index}`}/>);
        });
    };
    /**
     * В зависимости от статуса данных показать лоадер или
     * отрисовать карусель
     */
    const renderScrollSnap = () => {
        if (actionStatus === status.FETCHING) {
            return (<div className={s['scroll-placeholder']}>
          <Loader width="40" height="40"/>
        </div>);
        }
        else if (actionStatus === status.SUCCESS) {
            return (<ScrollSnap classNameItem={s.scrollItem} className={s.scrollSnap}>
          {renderItems()}
        </ScrollSnap>);
        }
        else {
            return null;
        }
    };
    const rootClass = classNames({
        [s['touch-content']]: isMobile,
    });
    return (<Wrapper dataQaDetail="ContentLayout" className={rootClass}>
      <Title level="2" className={s.title}>
        {title}
      </Title>
      {renderScrollSnap()}
      <div className={s['button-place']}>
        <button className={s['restart-button']} onClick={onRestart}>
          <RefreshIcon width="16" height="16"/> Повторить тест
        </button>
      </div>
    </Wrapper>);
};
export default FinishedQuiz;
